import { getAIEndpoint } from "../lib/env";
import { createFallbackSuggestions, type AIProvider, type GenerateSuggestionsInput } from "./AIProvider";

export function createWorkerAIProvider(endpoint = getAIEndpoint()): AIProvider {
  return {
    async generateSuggestions(input: GenerateSuggestionsInput) {
      try {
        const response = await fetch(endpoint, {
          method: "POST",
          headers: {
            "content-type": "application/json",
            ...(input.accessToken ? { authorization: `Bearer ${input.accessToken}` } : {}),
          },
          body: JSON.stringify({
            text: input.text,
            userId: input.userId,
          }),
        });

        if (!response.ok) throw new Error(`AI route returned ${response.status}`);
        return await response.json();
      } catch {
        return createFallbackSuggestions(input.text);
      }
    },
  };
}
